import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent } from '@mui/material'
import { ALIGN, CardTable, SORT } from 'common/components/datatable/Table'
import { BasicDialogTitle } from 'common/components/modal/DialogComponents'
import { getDate, getFullDateMini } from 'common/utils/DateUtil'
import { getIconPriority, truncateString } from 'common/utils/StringUtil'
import { getColorAdv } from 'common/utils/ColorUtil'
import { STATUS_TICKETS } from 'common/constants/Constants'
import { darkBlue } from 'app/theme'

// Mêmes colonnes que le tableau de suivi des devs (DevsApp), en lecture seule.
const HEADERS = [
    { key: 'avancement', value: '%' },
    { key: 'idIssue', value: 'Id' },
    { key: 'summary', value: 'Titre' },
    { key: 'handler', value: 'Affecté à' },
    { key: 'status', value: 'Statut' },
    { key: 'dueDate', value: 'Echéance' },
    { key: 'chiffrage', value: 'Chiffrage' },
    { key: 'tempspasse', value: 'Temps passé' },
    { key: 'priority', value: 'Priorité' },
    { key: 'category', value: 'Catégorie' },
    { key: 'reporter', value: 'Rapporteur' },
    { key: 'project', value: 'Projet' },
    { key: 'lastUpdated', value: 'Date maj' },
]

const formatRow = (t) => {
    const avancement = t.avancement ?? 0
    return {
        id: t.id,
        idIssue: { value: t.id },
        summary: { value: truncateString(t.summary, 60), tooltip: t.summary?.length > 60 ? t.summary : undefined },
        handler: { value: t.handler, sortValue: t.handler },
        status: { value: t.status, sortValue: STATUS_TICKETS.find(s => s.value === t.status)?.sortValue },
        dueDate: { value: t.dueDate && t.dueDate !== 1 ? getDate(t.dueDate * 1000) : '', sortValue: t.dueDate },
        chiffrage: { value: t.chiffrage ? `${t.chiffrage}h` : '', sortValue: parseInt(t.chiffrage) },
        tempspasse: { value: t.tempspasse ? `${t.tempspasse}h` : '', sortValue: parseInt(t.tempspasse) },
        priority: { value: t.priority, leftIcon: getIconPriority(t.priority) },
        category: { value: t.category },
        reporter: { value: t.reporter },
        project: { value: t.project },
        lastUpdated: { value: t.lastUpdated ? getFullDateMini(t.lastUpdated * 1000) : '', sortValue: t.lastUpdated },
        avancement: { value: <b>{avancement}</b>, sortValue: parseInt(avancement), color: getColorAdv(avancement), align: ALIGN.RIGHT },
    }
}

const PostReleaseBugsDialog = ({ open, onClose, version = '', tickets = [] }) => (
    <Dialog open={open} onClose={onClose} maxWidth='xl' fullWidth>
        <BasicDialogTitle onClose={onClose}>{`Bugs critiques post-release — Version ${version}`}</BasicDialogTitle>
        <DialogContent>
            <CardTable
                title={`${tickets.length} bug${tickets.length > 1 ? 's' : ''} critique${tickets.length > 1 ? 's' : ''} (Anomalie P1+P2, 15j post-release)`}
                color={darkBlue}
                headers={HEADERS}
                rows={tickets.map(formatRow)}
                rowsPerPageDefault={25}
                defaultSort={{ column: 'lastUpdated', direction: SORT.DESC }}
                onClickRow={({ id }) => window.open(`https://support.aquasys.fr/view.php?id=${id}`, '_blank')}
            />
        </DialogContent>
    </Dialog>
)

PostReleaseBugsDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    version: PropTypes.string,
    tickets: PropTypes.arrayOf(PropTypes.shape({})),
}

export default PostReleaseBugsDialog
